import styled from 'styled-components';

interface FilterButtonWrapperProps {
  isPremium?: boolean;
}

const FilterButtonWrapper = styled.div<FilterButtonWrapperProps>`
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: ${({ theme }) => theme.width.full};
  display: flex;
  justify-content: center;

  .container-card {
    min-width: 300px;
    max-width: 360px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    margin-left: ${({ theme }) => theme.spacing[12]};
    margin-right: ${({ theme }) => theme.spacing[12]};
    margin-bottom: ${({ theme, isPremium = false }) =>
      isPremium ? theme.spacing[96] : theme.spacing[24]};
    padding: ${({ theme }) => theme.spacing[16]};
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.primary.main};
    box-shadow: ${({ theme }) => theme.boxShadow.tooltip};

    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin-bottom: ${({ theme, isPremium = false }) =>
        isPremium ? theme.spacing[24] : undefined};
    }

    &--separator {
      border-left: 2px solid ${({ theme }) => theme.colors.primary.main};
      height: 170%;
      width: 2px;
      margin-right: ${({ theme }) => theme.spacing[8]};
    }
  }
`;

export default FilterButtonWrapper;
